module.exports = __webpack_public_path__ + "img/6-cartoon.e363332c.jpg";